export enum NotificationType {
  SYSTEM = "system",
  APPLICATION = "application",
  GENERAL = "general",
  ALERT = "alert",
}

export enum NotificationCategory {
  SYSTEM = "system",
  APPLICATION = "application",
  PAYMENT = "payment",
  EMAIL = "email",
  TASK = "task",
  SECURITY = "security",
  RISK = "risk",
}

export enum NotificationDisplayType {
  FEED = "feed",
  BANNER = "banner",
  TOAST = "toast",
}

export enum NotificationSeverity {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}

export type T_NotificationAction = {
  label: string;
  url: string;
  type?: "link" | "button";
};

export type T_NotificationAudience = {
  roles?: string[];
  users?: string[];
};

export type T_NotificationContext = {
  application?: string;
  user?: string;
  cardActivity?: string;
  template?: string;
  loan?: string;
  board?: string;
  card?: string;
};

export type T_Notification = {
  _id: string;

  type: NotificationType;
  category: NotificationCategory;

  title: string;
  message: string;

  priority: number;

  display_type: NotificationDisplayType;
  severity: NotificationSeverity;

  actions?: T_NotificationAction[];

  audience?: T_NotificationAudience;

  context?: T_NotificationContext;

  is_active?: boolean;
  expires_at?: string;

  createdAt: string;
  updatedAt: string;
};
